export const SET_MAP_AND_VIEW = 'map/SET_MAP_AND_VIEW'
export const SET_LEGEND_LAYER = 'map/SET_LEGEND_LAYER'
export const SET_SEARCH_RESULTS_LAYER = 'map/SET_SEARCH_RESULTS_LAYER'
export const SET_SELECTED_PARCELS = 'map/SET_SELECTED_PARCELS'